export default __webpack_public_path__ + "static/media/NoirPro-Heavy.fd447230.woff2";